import React from 'react';
import { useTranslation } from 'react-i18next';
import Paragraph from '@features/_common/components/Paragraph/Paragraph';
import List from '@features/_common/components/List/List';
import style from './privacy.module.scss';

export default function PrivacyPage() {
  const { t } = useTranslation('privacy\\Privacy');

  const purposeUl = [
    { id: 'purpose-ul-1', text: t('privacyPurposeUl1') },
    { id: 'purpose-ul-2', text: t('privacyPurposeUl2') },
    { id: 'purpose-ul-3', text: t('privacyPurposeUl3') },
    { id: 'purpose-ul-4', text: t('privacyPurposeUl4') },
    { id: 'purpose-ul-5', text: t('privacyPurposeUl5') },
    { id: 'purpose-ul-6', text: t('privacyPurposeUl6') },
  ];

  const legitimationUl = [
    { id: 'legitimation-ul-1', text: t('privacyLegitimationUl1') },
    { id: 'legitimation-ul-2', text: t('privacyLegitimationUl2') },
    { id: 'legitimation-ul-3', text: t('privacyLegitimationUl3') },
    { id: 'legitimation-ul-4', text: t('privacyLegitimationUl4') },
  ];

  const recipientsUl = [
    { id: 'recipients-ul-1', text: t('privacyRecipientsUl1') },
    { id: 'recipients-ul-2', text: t('privacyRecipientsUl2') },
  ];

  const hostedContentIntellectualPropertyUl = [
    {
      id: 'hosted-content-ip-ul-1',
      text: t('privacyHostedContentIntellectualPropertyUl1'),
    },
    {
      id: 'hosted-content-ip-ul-2',
      text: t('privacyHostedContentIntellectualPropertyUl2'),
    },
    {
      id: 'hosted-content-ip-ul-3',
      text: t('privacyHostedContentIntellectualPropertyUl3'),
    },
    {
      id: 'hosted-content-ip-ul-4',
      text: t('privacyHostedContentIntellectualPropertyUl4'),
    },
    {
      id: 'hosted-content-ip-ul-5',
      text: t('privacyHostedContentIntellectualPropertyUl5'),
    },
  ];

  return (
    <main className={style.container}>
      <h1 className={style.title}>{t('privacyTitle')}</h1>

      <Paragraph title={t('privacySubTitle')} text={t('privacyIntroP1')} />
      <Paragraph text={t('privacyIntroP2')} />
      <Paragraph text={t('privacyIntroP3')} />
      <Paragraph text={t('privacyIntroP4')} />
      <Paragraph text={t('privacyIntroP5')} />
      <Paragraph text={t('privacyIntroP6')} />
      <Paragraph text={t('privacyIntroP7')} />

      <Paragraph
        title={t('privacyPurpose')}
        text={t('privacyPurposeQuestion')}
      />
      <Paragraph text={t('privacyPurposeP1')} />
      <List type="ul" listData={purposeUl} />

      <Paragraph title={t('privacyRetention')} text={t('privacyRetentionP1')} />

      <Paragraph
        title={t('privacyLegitimation')}
        text={t('privacyLegitimationP1')}
      />
      <List type="ul" listData={legitimationUl} />
      <Paragraph text={t('privacyLegitimationP2')} />

      <Paragraph
        title={t('privacyRecipients')}
        text={t('privacyRecipientsP1')}
      />
      <List type="ul" listData={recipientsUl} />
      <Paragraph text={t('privacyRecipientsP2')} />
      <Paragraph text={t('privacyRecipientsP3')} />
      <Paragraph text={t('privacyRecipientsP4')} />

      <Paragraph title={t('privacyUserData')} text={t('privacyUserDataP1')} />

      <Paragraph
        title={t('privacySiteIntellectualProperty')}
        text={t('privacySiteIntellectualPropertyP1')}
      />
      <Paragraph text={t('privacySiteIntellectualPropertyP2')} />

      <Paragraph
        title={t('privacySoftwareIntellectualProperty')}
        text={t('privacySoftwareIntellectualPropertyP1')}
      />
      <Paragraph text={t('privacySoftwareIntellectualPropertyP2')} />
      <Paragraph text={t('privacySoftwareIntellectualPropertyP3')} />
      <Paragraph text={t('privacySoftwareIntellectualPropertyP4')} />

      <Paragraph
        title={t('privacyHostedContentIntellectualProperty')}
        text={t('privacyHostedContentIntellectualPropertyP1')}
      />
      <List type="ul" listData={hostedContentIntellectualPropertyUl} />
      <Paragraph text={t('privacyHostedContentIntellectualPropertyP2')} />
      <Paragraph text={t('privacyHostedContentIntellectualPropertyP3')} />
      <Paragraph text={t('privacyHostedContentIntellectualPropertyP4')} />

      <Paragraph
        title={t('privacyHostedInformationProtection')}
        text={t('privacyHostedInformationProtectionP1')}
      />
      <Paragraph text={t('privacyHostedInformationProtectionP2')} />
      <Paragraph text={t('privacyHostedInformationProtectionP3')} />
      <Paragraph text={t('privacyHostedInformationProtectionP4')} />

      <Paragraph
        title={t('privacyCommercialCommunications')}
        text={t('privacyCommercialCommunicationsP1')}
      />
      <Paragraph text={t('privacyCommercialCommunicationsP2')} />
      <Paragraph text={t('privacyCommercialCommunicationsP3')} />
    </main>
  );
}